// extracted by mini-css-extract-plugin
export var card = "_v1-0";
export var details = "_v1-1";